module.exports = __webpack_public_path__ + "static/media/ehp-black.b5d13bcd.svg";